import { inject } from "@telia/b2x-adtraction";
import { onceConsented } from "@telia/b2x-cookie-consent";
import { rule } from "@telia/b2x-url-segments";

import { w } from "../util";

export const initAdTraction = () => {
  const COOKIE_GROUP = "C0004";

  if (w) {
    const r = rule(new URL(w.location.href));

    if (r.isPublic && r.isB2C) {
      onceConsented(COOKIE_GROUP, "Enable Giosg in B2C").then(() => inject());
    }
  }
};
